import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { lightstepConfigFactory } from '@dgx-pr-spa/shared/util';
import {
  ENVIRONMENT,
  SharedUiComponentsModule,
} from '@dgx-pr-spa/ui-components';
import { DgxComponentsLayoutModule } from '@domgen/dgx-fe-components/layout';
import { CONFIG, DgxConfigModule } from '@domgen/dgx-fe-config';
import { GA_CONFIG } from '@domgen/dgx-fe-ga';
import { DgxLightstepModule, LIGHTSTEP_CONFIG } from '@domgen/dgx-fe-lightstep';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import { environment } from '@pr/util-environment';
import { ModelComparisonModule } from './model-comparison/model-comparison.module';
import { PrAppComponent } from './pr-app.component';
import { PrFeatureShellCommonModule } from './pr-feature-shell-common.module';
import { PrRoutingModule } from './pr-feature-shell-routing.module';

@NgModule({
  imports: [
    CommonModule,
    DgxQmModule,
    PrRoutingModule,
    ModelComparisonModule,
    SharedUiComponentsModule,
    PrFeatureShellCommonModule,
    DgxQmModule.forRoot(),
    DgxConfigModule.forRoot(),
    DgxLightstepModule.forRoot(),
    DgxComponentsLayoutModule,
  ],
  exports: [RouterModule, PrAppComponent],
  declarations: [PrAppComponent],
})
export class PrFeatureShellModule {
  static forRoot(): ModuleWithProviders<PrFeatureShellModule> {
    return {
      ngModule: PrFeatureShellModule,
      providers: [
        {
          provide: GA_CONFIG,
          useValue: {
            debug: true,
          },
        },
        {
          provide: ENVIRONMENT,
          useValue: environment,
        },
        {
          provide: LIGHTSTEP_CONFIG,
          useFactory: lightstepConfigFactory,
          deps: [CONFIG],
        },
      ],
    };
  }
}
